import React, { useState, createContext } from 'react';
import { TextField } from '@habitech/keychain-atoms-inputs';
import { Button } from '@habitech/call-to-action';
import { GridItem } from 'src/components/common/grids';
import { SearchWrapper, Pmodal, Title } from './styles';
import { migrateFeedToManualApi } from './../../apis/postMigrateFeed';
import { useSelector } from 'react-redux';
import { RootState } from './../../redux/RootState';
import 'react-datepicker/dist/react-datepicker.css';
import Modal from '../common/modal/Modal';
import { getSummary, extendValidity, basicInformation, getUserEmailContactSummary, getBannedUsers } from 'src/apis/migrateSummary';
import * as yup from 'yup';
import { useFormik } from 'formik';
import { MigrateByIdContextType, MigrateFromSummaryContextType, propertiesSummary, BannedUsers } from './types';
import Tabs from '../common/TabSwich/Tabs';
import { configFile } from './constants';
import { setNewEmail } from 'src/redux/migrate_feed/migrateFeedSlice';
import { setNewEmailContact, setPhone } from 'src/redux/migrate_email_contact/migrateEmailContact';
import { setFeedName, setUserId, setLoading } from 'src/redux/unban_user/slice';
import { useAppDispatch, useAppSelector } from 'src/hooks/redux';

export const MigrateFromSummary = createContext<MigrateFromSummaryContextType>({});
export const MigrateByIdContext = createContext<MigrateByIdContextType>({});

const MigrateFeed = () => {

	const [apiResult, setApiResult] = useState(null);
	const [extendValidityResult, setExtendValidityResult] = useState(null);
	const token = useSelector((state: RootState) => state.User.token);
	const [loadingMigration, setLoadingMigration] = useState(false);
	const [loadingSummary, setLoadingSummary] = useState(false);
	const [loadingSearchedProperties, setLoadingSearchedProperties] = useState(false);
	const [showModal, setShowModal] = useState(false);
	const [showModalSummary, setShowModalSummary] = useState(false);
	const [errorFeed, setErrorFeed] = useState(false);
	const [searchedProperties, setSearchedProperties] = useState([]);
	const [migrationByIdState, setMigrationByIdState] = useState('');
	const [migrateAllState, setMigrateAllState] = useState('');
	const [activeTab, setActiveTab] = useState(0);
    const {phoneError} = useAppSelector((state) => state.migrate_email_contact);
	const [summaryByEmailContact, setSummaryByEmailContact] = useState<propertiesSummary>();
	const [bannedUsers, setBannedUsers] = useState<BannedUsers>();
	const dispatch = useAppDispatch();

	const errorMsg = 'Debe escribir los Ids separados por comas';
	const propertySearchValidationSchema = yup.object({
		propertyIds: yup.string().matches(
			/^\s*\d+(\s*,\s*\d+)*\s*$/,
			errorMsg
		).required(errorMsg),
	});

	const searchPropertiesForm = useFormik({
		initialValues: { propertyIds: "" },
		validationSchema: propertySearchValidationSchema,
		onSubmit: async (values) => {
			if (!userSummary.values.email) {
				userSummary.setErrors({ email: "Ingrese un email válido" })
				return
			}
			setLoadingSearchedProperties(true)
			const res = await basicInformation(values.propertyIds, userSummary.values.email)
			if (res.success) {
				setSearchedProperties(res.data)
			}
			setLoadingSearchedProperties(false)
		},
	});

	const userSummaryValidationSchema = yup.object({
		email: yup.string().email().required("Ingrese un email válido"),
	});

	const searchUserUmmary = (email: string) => {
		setLoadingSummary(true);
		getSummary(email).then((summary) => {
			if (summary.success) {
				setSummary(summary);
			} else {
				setSummary({} as propertiesSummary)
			}
			setLoadingSummary(false);
		}).catch((error) => {
			console.error(error)
		})
	}
	/**servicio david */
	const searchUserEmailContactSummary = (email: string) => {
		setLoadingSummary(true);
		getUserEmailContactSummary(email).then((summari) => {
			if (summari.success) {
				setSummaryByEmailContact(summari);
			} else {
				setSummaryByEmailContact({} as propertiesSummary)
			}
			setLoadingSummary(false);
		}).catch((error) => {
			console.error(error)
		})
	}

	const searchBannedUsers = (email: string) => {		
		dispatch(setLoading(true));
		getBannedUsers(email, state.feedName, token).then((bannedUsers) => {
			if (bannedUsers.data && Object.keys(bannedUsers.data).length > 0) {
				setBannedUsers(bannedUsers);
				dispatch(setUserId(bannedUsers.data.user_id));
				dispatch(setFeedName(bannedUsers.data.feed_name));
			} else {
				setBannedUsers({} as BannedUsers)
			}
		}).catch((error) => {
			console.error(error)
			setBannedUsers({} as BannedUsers)
		}).finally(() => dispatch(setLoading(false)));
	}

	const userSummary = useFormik({
		initialValues: { email: "" },
		validationSchema: userSummaryValidationSchema,
		onSubmit: async (values) => {
			switch (activeTab) {
				case 5:
					searchUserEmailContactSummary(values.email);
					break;
				case 6:
					searchBannedUsers(values.email);
					break;
				default:
					searchUserUmmary(values.email);
			}
		}
	});

	const [summary, setSummary] = useState<propertiesSummary>();

	const [state, setState] = useState<{
		feedName: string;
		mail: string;
		newmail: string;
	}>({
		feedName: '',
		mail: '',
		newmail: '',
	});

	const handleCloseModal = () => {
		setShowModal(false);
	};

	const handleCloseModalExtension = () => {
		setShowModalSummary(false);
	};

	function validateState(field, setErrorFunc) {
		if (!field || field.trim() === "") {
			setErrorFunc(true);
			return false; // No se llama a la API si el estado es vacío o nulo
		} else {
			setErrorFunc(false);
			return true;
		}
	}

	const migrate = (properties: string, migrationState: string) => {

		// Usar la función de validación para el campo 'feedName'
		if (!validateState(state.feedName, setErrorFeed)) return;


		if (!userSummary.values.email) {
			userSummary.setErrors({ email: "Ingrese un email válido" })
			return
		}

		if (Object.keys(userSummary.errors).length > 0) return;

		setLoadingMigration(true)
		migrateFeedToManualApi(state.feedName, userSummary.values.email, state.newmail, token, properties, migrationState)
			.then((res) => {
				setApiResult(res.errors.message);
			})
			.finally(() => {
				setShowModal(true);
				setLoadingMigration(false);
				userSummary.resetForm()
				searchPropertiesForm.resetForm()
				setSearchedProperties([])
				setSummary({} as propertiesSummary)
			});
	};

	const handleMigrateAll = async () => {
		if (summary?.data?.allProperties) {
			const properties = summary.data.allProperties.join(",");
			migrate(properties, migrateAllState)
		}
	}

	const handleMigrateFromList = async () => {
		if (searchPropertiesForm) {
			const properties = searchedProperties.map((p) => { return p.id }).join(",")
			migrate(properties, migrationByIdState)
		}
	}

	function handleInputChange(name: string, value: any) {
		setState({
			...state,
			[name]: value
		});
	}

	function handlePhoneChangeEmailContact(name: string, value: any) {
		dispatch(setPhone(value))
	}

	function handleNewMailChangeEmailContact(name: string, value: any) {
		dispatch(setNewEmailContact(value))
	}

	const handleExtend15Days = () => {
		if (summary.data.due15DaysProperties.length > 0) {
			extendValidity(summary.data.due15DaysProperties).then((res) => {
				if (res.errors.code === 200) {
					setExtendValidityResult(res.data)
					setShowModalSummary(true)
					setTimeout(() => {
						setShowModalSummary(false)
					}, 3000)
					searchUserUmmary(userSummary.values.email)
				}
			}).catch((e) => { console.error(e) })
		}
	}

	const handleExtend30Days = () => {
		if (summary.data.due30DaysProperties.length > 0) {
			extendValidity(summary.data.due30DaysProperties).then((res) => {
				if (res.errors.code === 200) {
					setExtendValidityResult(res.data);
					setShowModalSummary(true);
					setTimeout(() => {
						setShowModalSummary(false)
					}, 3000)
					searchUserUmmary(userSummary.values.email)
				}
			}).catch((e) => { console.error(e) })
		}
	}

	const onChangeNewMail = (name,_value) => {
		if (activeTab === 5) {
			handleNewMailChangeEmailContact(name, _value)
		} else {
			handleInputChange(name, _value)
			dispatch(setNewEmail(_value))
		}
	}

	return (
		<div>
			<Title>Migrar usuario de Feed a Manual o Expandir Vigencia</Title>

			<MigrateFromSummary.Provider
				value={{
					summary,
					migrateAllState,
					setMigrateAllState,
					handleMigrateAll,
					loadingMigration,
					loadingSummary,
					handleExtend15Days,
					handleExtend30Days,
					userSummary
				}}>
				<MigrateByIdContext.Provider
					value={{
						searchPropertiesForm,
						searchedProperties,
						migrationByIdState,
						setMigrationByIdState,
						handleMigrateFromList,
						loadingMigration,
						loadingSearchedProperties
					}}
					>

					<SearchWrapper>
						
						{ 
							activeTab !== 5 ? (
								<>
								<GridItem sm={8} md={8} lg={8}>
									<TextField
										dataId="feed-name"
										name="feedName"
										label="Ingrese Feed name"
										originType="pcom"
										placeHolder="Digite el Feed name (Obligatorio para migración)"
										innerLabel
										defaultValue=""
										onChange={(_, _value) => handleInputChange(_, _value)}
										error={errorFeed}
										errorMessage={'Debe escribir un feed Name'}
										/>
								</GridItem>

							</>
							) : (
								<GridItem sm={8} md={8} lg={8}>
									<TextField
										dataId="new-user-phone"
										name="newUserPhone"
										label="Ingrese el número de teléfono"
										originType="pcom"
										placeHolder="Digite el número de contactación"
										innerLabel
										defaultValue=""
										onChange={(_, _value) => handlePhoneChangeEmailContact(_, _value)}
										error={phoneError}
										errorMessage={'Ingrese un númerio de teléfono válido'}
										/>
								</GridItem>
							)
						}
						<GridItem sm={8} md={8} lg={8}>
							<form onSubmit={userSummary.handleSubmit}>
								<SearchWrapper>
									<GridItem sm={4} md={6} lg={8}>
										<TextField
											dataId="email"
											name="email"
											label="Correo"
											originType="pcom"
											placeHolder="Ingrese el correo (Obligatorio)"
											innerLabel
											value={userSummary.values.email}
											onChange={(_, _value, e) => { userSummary.handleChange(e) }}
											error={Boolean(userSummary.errors.email)}
											errorMessage={JSON.stringify(userSummary.errors.email)}
											maxLength={3000}
											/>
									</GridItem>

									<GridItem sm={1} md={1} lg={1}>

										<Button dataId="button-search" originType="pcom" size="medium" fluid type="submit">
											Buscar
										</Button>
									</GridItem>
								</SearchWrapper>
							</form>
						</GridItem>	
						{
							activeTab !== 6 &&
							<GridItem sm={8} md={8} lg={8}>
								<TextField
									dataId="new-mail"
									name="newmail"
									label="Nuevo correo"
									originType="pcom"
									placeHolder="Ingrese el nuevo correo (Opcional)"
									innerLabel
									defaultValue=""
									onChange={onChangeNewMail}
								/>
							</GridItem>
						}
					</SearchWrapper>
								
					<GridItem sm={8} md={8} lg={8}>
						<Tabs 
							configFile={configFile} 
							activeTab={activeTab} 
							setActiveTab={setActiveTab} 
							contactEmail={userSummary.values.email}
							summaryByEmailContact={summaryByEmailContact}
							loadingSummary={loadingSummary}
							bannedUsers={bannedUsers}
						/>
					</GridItem>

					<GridItem sm={8} md={8} lg={8}>
						{showModal && (
							<Modal onClose={handleCloseModal}>
								<div>
									<img src="/images/logo-propiedades.svg" alt="logo propiedades" />
								</div>
								{apiResult ? <Pmodal>{apiResult}</Pmodal> : <p></p>}
							</Modal>
						)}
					</GridItem>
					{
						showModalSummary && (
							<Modal onClose={handleCloseModalExtension}>
								<div>
									<img src="/images/logo-propiedades.svg" alt="logo propiedades" />
								</div>
								{extendValidityResult ? <Pmodal>{extendValidityResult}</Pmodal> : <p></p>}
							</Modal>
						)
					}

				</MigrateByIdContext.Provider>
			</MigrateFromSummary.Provider>
		</div >
	);
};

export default MigrateFeed;